
import * as Dialog from '@radix-ui/react-dialog';
import { motion, AnimatePresence } from 'framer-motion';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
}

export function Modal({ open, onClose, title, children }: ModalProps) {
    return (
        <Dialog.Root open={open} onOpenChange={onClose}>
            <AnimatePresence>
                {open && (
                    <Dialog.Portal forceMount>
                        <Dialog.Overlay asChild>
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                style={{
                                    position: 'fixed',
                                    inset: 0,
                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    backdropFilter: 'blur(4px)',
                                    zIndex: 9998,
                                }}
                            />
                        </Dialog.Overlay>
                        <Dialog.Content asChild>
                            <motion.div
                                initial={{ opacity: 0, scale: 0.95, y: 20 }}
                                animate={{ opacity: 1, scale: 1, y: 0 }}
                                exit={{ opacity: 0, scale: 0.95, y: 20 }}
                                transition={{ duration: 0.2 }}
                                style={{
                                    position: 'fixed',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'var(--color-bg-elevated)',
                                    borderRadius: 'var(--radius-lg)',
                                    padding: 'var(--spacing-xl)',
                                    boxShadow: 'var(--shadow-xl)',
                                    maxWidth: '500px',
                                    width: '90%',
                                    maxHeight: '85vh',
                                    overflow: 'auto',
                                    zIndex: 9999,
                                }}
                            >
                                <Dialog.Title
                                    style={{
                                        fontSize: '1.5rem',
                                        fontWeight: 600,
                                        marginBottom: 'var(--spacing-lg)',
                                        color: 'var(--color-text-primary)',
                                    }}
                                >
                                    {title}
                                </Dialog.Title>
                                {children}
                            </motion.div>
                        </Dialog.Content>
                    </Dialog.Portal>
                )}
            </AnimatePresence>
        </Dialog.Root>
    );
}
